// @flow

import React from 'react';
import { Route, Switch } from 'react-router-dom';

import CartListings from './Listings';
import CartPayment from './Payment';
import CartSuccess from './Success';

const routes = [
  { path: '/cart', Component: CartListings },
  { path: '/cart/payment', Component: CartPayment },
  { path: '/cart/payment/:invoiceId/payment-success', Component: CartSuccess },
];

export default function CartScreen() {
  return (
    <Switch>
      {routes.map(r => <Route key={r.path} exact path={r.path} component={r.Component} />)}
    </Switch>
  );
}


// WEBPACK FOOTER //
// ./src/screens/Cart/Home.js